module.exports = __webpack_public_path__ + "static/media/cover.5277b834.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/AboutMe/cover.jpg
// module id = 116
// module chunks = 0